import React from 'react'
import { PropTypes } from 'prop-types'
import ContractorRow from './ContractorRow'

class ContractorGrid extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(contractor) {
    this.props.onSelect(contractor)
  }

  renderHeaderCell = (title, size) => (
    <td className="ln-c-table__header-cell ln-o-generic--no-wrap" style={{ width: size }}>
      {title}
    </td>
  )

  render() {
    const rows = []

    this.props.contractors.forEach((contractor) => {
      rows.push(<ContractorRow
        employerId={this.props.employerId}
        contractor={contractor}
        key={contractor.id}
        onSelect={this.handleSelect}
        isReadOnly={this.props.isReadOnly}
      />)
    })

    return (
      <div className="ln-c-table-container">
        <table className="ln-c-table">
          <thead className="ln-c-table__header">
            <tr className="ln-c-table__row ln-c-table__header-row ">
              {this.renderHeaderCell('Colleague name', '20%')}
              {this.renderHeaderCell('Job role', '16%')}
              {this.renderHeaderCell('Telephone number', '16%')}
              {this.renderHeaderCell('Car registration', '16%')}
              {this.renderHeaderCell('Unique ID', '16%')}
              {this.renderHeaderCell('Registered on', '16%')}
            </tr>
          </thead>
          <tbody className="ln-c-table__body">{rows}</tbody>
        </table>
      </div>
    )
  }
}

ContractorGrid.propTypes = {
  employerId: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  contractors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired
    })
  ).isRequired
}

export default ContractorGrid



// WEBPACK FOOTER //
// ./src/components/ContractorGrid/index.jsx